const ExitPopup = () => {

    let cookieStatus = false;

    function setCookie(name, value, daysToExpire) {
        const date = new Date();
        date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    const exitPopups = document.getElementsByClassName('exit-popup')[0];
    const exitPupupsClose = document.getElementsByClassName('exit-popup__close');
    const exitPopupForm = document.querySelectorAll('.custom-lead form');

    if(exitPopups) {
        var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if(screenWidth > 1024) {
            if(exitPopups.classList.contains('after10')) {
                setTimeout(() => {
                    exitPopups.classList.add('active');
                }, 10000);
            } else {
                document.getElementsByTagName('body')[0].addEventListener('mouseleave', function() {
                    if(cookieStatus === false && !exitPopups.classList.contains('only-on-click')) {
                        exitPopups.classList.add('active');
                    }
                });
            }
        } else {
            setTimeout(() => {
                exitPopups.classList.add('active');
            }, 30000);
        }

        if(exitPopupForm) {
            for(var i = 0; i < exitPopupForm.length; i++) {
                exitPopupForm[i].addEventListener('submit',function() {
                    setTimeout(() => {
                        const getExitPopupForm = this.closest('.custom-lead');
                        if(getExitPopupForm) {
                            if(!getExitPopupForm.classList.contains('custom-lead-errors')) {
                                exitPopups.classList.remove('active');
                                setCookie("exitPopup", "displayed", 1);
                                cookieStatus = true;
                                if(exitPopups.classList.contains('nadcisnienie1')) {
                                    window.location.href = "/dziekujemy";
                                }
                                if(getExitPopupForm.classList.contains('custom-lead--aside--nadcisnienie')) {
                                    window.location.href = "/dziekujemy";
                                }
                                console.log(getExitPopupForm.classList);
                            }
                        }
                    }, 5000);
                })
            }
        }

        document.addEventListener( 'wpcf7mailsent', function( event ) {
            setTimeout(() => {
                exitPopups.classList.remove('active');
                setCookie("exitPopup", "displayed", 1);
                cookieStatus = true;
            }, 2000);
        }, false );

        exitPopups.addEventListener('click', function(el) {
            if(el.target.classList.contains('exit-popup')) {
                exitPopups.classList.remove('active');
                setCookie("exitPopup", "displayed", 1);
                cookieStatus = true;
            }

        })
        const openExitPopupOnClick = document.getElementsByClassName('open-exit-popup');

        if(openExitPopupOnClick) {
            for(var i = 0; i < openExitPopupOnClick.length; i++) {
                openExitPopupOnClick[i].addEventListener('click', function() {

                    exitPopups.classList.add('active');

                })
            }
        }
    }

    if(exitPopupForm) {
        for(var i = 0; i < exitPopupForm.length; i++) {
            exitPopupForm[i].addEventListener('submit',function() {
                setTimeout(() => {
                    const getExitPopupForm = this.closest('.custom-lead');
                    if(getExitPopupForm) {
                        if(!getExitPopupForm.classList.contains('custom-lead-errors')) {
                            if(getExitPopupForm.classList.contains('custom-lead--aside--nadcisnienie')) {
                                window.location.href = "/dziekujemy";
                            }
                            if(getExitPopupForm.classList.contains('redirect-newsletter')) {
                                const emailValue = getExitPopupForm.querySelector('input[type="email');
                                window.location.href = "/dziekujemy-newsletter?email-newsletter=" + emailValue.value;
                            }
                        }
                    }
                }, 5000);
            })
        }
    }


    if(exitPupupsClose) {
        for(var i = 0; i < exitPupupsClose.length; i++) {
            exitPupupsClose[i].addEventListener('click', function() {
                if(exitPopups) {
                    exitPopups.classList.remove('active');
                    setCookie("exitPopup", "displayed", 1);
                    cookieStatus = true;
                }
            })
        }
    }

}

export default ExitPopup;